import React from 'react';
import styled from 'styled-components/macro';
import { TickboxProps } from '../types/TickboxProps';

const UnstyledTickbox: React.FC<TickboxProps> = ({
  className,
  children,
  name,
  value,
  onTick,
}) => {
  return (
    <div
      className={'ww-tickbox ' + className}
      onClick={() => onTick?.(name, value)}
      data-name={name}
      data-id={value}
      data-testid="tickbox"
    >
      <div className="symbol">
        <i className="icon-ok" data-testid="tickbox-icon" />
      </div>
      <span className="label">{children && <div>{children}</div>}</span>
    </div>
  );
};

const Tickbox = styled(UnstyledTickbox)`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;

  .symbol {
    flex: none;
    width: 1.7em;
    height: 1.7em;
    margin-right: 0.75em;
    background-color: ${(props) =>
      props.active === null
        ? 'var(--gray-3)'
        : props.active
        ? 'var(--secondary-color)'
        : 'transparent'};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    box-shadow: ${(props) =>
      props.active == null || props.active
        ? 'none'
        : '0 0 0 1px rgba(0,0,0,0.2) inset'};
    transition: background-color 200ms ease-out, box-shadow 100ms ease-out;
    border-radius: ${(props) => (props.circular ? '100%' : 'initial')};
  }

  :hover .symbol {
    box-shadow: ${(props) =>
      props.active != null && props.active
        ? 'none'
        : '0 0 0 2px var(--secondary-color) inset'};
  }

  .symbol i {
    color: var(--white);
    display: ${(props) =>
      props.active == null || props.active ? 'block' : 'none'};
    margin-bottom: 0.1em;
  }

  .label {
    user-select: none;
  }
`;

export default Tickbox;
